import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { takeUntil } from 'rxjs/operators' ;  import { Subject } from 'rxjs';
import { UserSessionService } from '../../shared';
import { ModalService } from '../../blocks';
import { MarkPatExpectedServiceSearch, MarkPatExpectedServiceService } from '../../markting/mark-pat-expected-service/mark-pat-expected-service.service';

@Component({
    selector: 'call-data-show-leads-calls',
    templateUrl: './call-data-show-leads-calls.component.html',
    providers: [MarkPatExpectedServiceService]

})

export class CallDataShowLeadsCallsComponent implements OnInit, OnDestroy {
    private ngUnsubscribe: Subject<void> = new Subject<void>();
    markPatExpectedServiceSearchObj = <MarkPatExpectedServiceSearch>{}

    markLeadList = [];
    markLeadCallsList = [];
 
    constructor(
        public translate: TranslateService,
        private _userSessionService: UserSessionService,
        private _MarkPatExpectedServiceService: MarkPatExpectedServiceService,
        private _modalService: ModalService
    ) { }

    ngOnInit() {
        this._userSessionService.subscribeToKey$('patientCallLeads')
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((keys: any) => {
           
            if (keys.value) {
                this.markLeadList = [] ;
                this.markLeadCallsList = [];
               this.markPatExpectedServiceSearchObj.patCode = keys.value.patCode;
               this.markPatExpectedServiceSearchObj.cCCallBeneficiary = keys.value.ccCallBeneficiarySerial;
               this._getMarkPatExpectedService()
              console.log(keys.value)
            }
        });
      
    }

    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }

    _getMarkPatExpectedService() {
        this.markLeadList = [] ;
        this._MarkPatExpectedServiceService.getLeadsByDoctors(this.markPatExpectedServiceSearchObj)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(
                requests => {
                    this.markLeadList = requests.data;  
                },
                error => console.log(error),
                () => { });
    }

    resetLeadsList(){
        this.markLeadList = [] ;
        this.markLeadCallsList = [];
        console.log('_____reset Leads List')
    }

    onRowClick(actionCode: number, masterLead: any) {
        switch (actionCode) {
          case 404:
            this.getLeadsDetail(masterLead)
            console.log(masterLead)
            break; 
    
          default:
            break;
        }
      }


      getLeadsDetail(masterLead){
        this.markPatExpectedServiceSearchObj.serial = masterLead.serial
        this.markPatExpectedServiceSearchObj.mark_LeadsSerial = masterLead.serial
        this.markPatExpectedServiceSearchObj.patientCode = masterLead.patientCode
        this.markPatExpectedServiceSearchObj.serviceCode = masterLead.serviceId
        this.markPatExpectedServiceSearchObj.visitSerial = masterLead.visitSerial
        this.markPatExpectedServiceSearchObj.leadTypeFlag = 1
        this._getMarkPatExpectedServiceDetail()
      }

      _getMarkPatExpectedServiceDetail() {
        this.markLeadCallsList = [];
        this._MarkPatExpectedServiceService.getMarkPatExpectedServiceDetail(this.markPatExpectedServiceSearchObj)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(c => {
                if (c && c.data && c.data.length > 0) {
                    this.markLeadCallsList = c.data; 
                } 
            });
    }

 
}



